// extracted by mini-css-extract-plugin
export var content = "empty-courses-module--content--526bc";
export var title = "empty-courses-module--title--d6f5e";
export var wrapper = "empty-courses-module--wrapper--b7b5f";